import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { getDateDifferenceFormatted } from "./components/Coverages";
import { Chip, Divider } from "@mui/material";
import { getColor } from "../../../PreAuth/components/response/ResponseDetailsComponentNew";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import EligibilityItemsTable from "./components/EligibilityItemsTable";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../../shared/CustomFilterInput";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";

function Row(props) {
  const { t } = useTranslation();
  const { row, index, openRow, setOpenRow } = props;
  const isOpen = openRow === index;
  const [expanded, setExpanded] = React.useState(null);
  const handleRowClick = () => {
    setOpenRow(isOpen ? null : index);
  };
  return (
    <React.Fragment>
      <TableRow
        onClick={handleRowClick}
        className=" bg-[#007bff)] cursor-pointer"
      >
        <TableCell className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900">
          {isOpen ? (
            <VisibilityOff fontSize="small" />
          ) : (
            <Visibility fontSize="small" />
          )}
        </TableCell>
        {/* <TableCell
          className='!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900'
          component='th'
          scope='row'
        >
          {row?.in_force || '__'}
        </TableCell> */}
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {getDateDifferenceFormatted(row?.benefit_date) || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.member_id || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.policy_number || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.policy_holder || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.type || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.relation_with_subscriber || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.subscriber_member_id || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.network || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.subrogation || "__"}
        </TableCell>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.status ? (
            <Chip
              label={row?.status}
              color={getColor(row?.status)}
              size="small"
              className="uppercase !text-white !text-base !text-[15px] !font-[600]"
              style={{ color: "white !important" }}
            />
          ) : (
            "__"
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          rowSpan={2}
          className="!whitespace-pre-wrap border bg-gray-500 text-white border-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold  sm:!pl-2"
        >
          {t("Classes")}
        </TableCell>
        <TableCell className="!whitespace-pre-wrap  bg-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold !text-white sm:!pl-2">
          {t("Class")}
        </TableCell>
        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap bg-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold !text-white sm:!pl-2"
        >
          {t("Group")}
        </TableCell>
        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap bg-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold !text-white sm:!pl-2"
        >
          {t("Plan")}
        </TableCell>

        <TableCell
          rowSpan={2}
          className="!whitespace-pre-wrap border bg-gray-500 text-white border-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold  sm:!pl-2"
        >
          {t("Cost to Beneficiaries")}
        </TableCell>
        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap bg-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold !text-white sm:!pl-2"
        >
          {t("Copay")}
        </TableCell>

        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap bg-gray-500  !py-[7px] !pl-4 !pr-3 !text-left text-sm !font-semibold !text-white sm:!pl-2"
        >
          {t("Maxcopay")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.class_value || "__"}
        </TableCell>
        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.class_group_value || "__"}
        </TableCell>
        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.class_plan_value || "__"}
        </TableCell>

        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.cost_to_ben_copay_value || 0}
        </TableCell>

        <TableCell
          colSpan={2}
          className="!whitespace-pre-wrap !px-2 !py-2 text-sm !text-gray-900"
          align="left"
        >
          {row?.cost_to_ben_max_copay_value || 0}
        </TableCell>
      </TableRow>
      <Divider sx={{ mb: 4 }} />
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }} className="border p-3 rounded-md !w-full">
              <Typography
                className="flex gap-3 justify-between !w-[100%] !font-bold mb-2 !text-[18px]"
                variant="h6"
                sx={{ width: "50%", flexShrink: 0 }}
              >
                <span>{t("Items")}</span>
              </Typography>
              {/* {expanded === index && ( */}
              <EligibilityItemsTable data={row?.items} />
              {/* )} */}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function CoverageCard({ row, index }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false); // Default all ones to closed
  const [localSearchTerm, setLocalSearchTerm] = React.useState("");
  const isSuccess = row?.status === "active" || row?.status === "Success";

  return (

    <>
      <div className="w-full flex flex-col border border-gray-200 rounded-md overflow-hidden bg-white shadow-sm ">
        {/* Header Table */}
        <div className="transition-colors">
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse">
              <thead className="bg-[#d1d5db]">
                <tr className="uppercase tracking-tight">
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Status")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Benefit Date")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Member ID")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Policy No.")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Holder")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px) leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Type")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Relation")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Sub Member ID")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Network")}
                  </th>
                  <th className="px-1.5 py-1.5 text-left text-[11px] leading-tight font-[700] text-[#1e293b] border-r border-white/40 whitespace-nowrap">
                    {t("Subrogation")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px]">
                    {row?.status ? (
                      <span
                        className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase ${isSuccess ? "bg-[#dcfce7] text-[#22c55e]" : "bg-[#fee2e2] text-[#ef4444]"
                          }`}
                      >
                        {row?.status}
                      </span>
                    ) : (
                      t("N/A")
                    )}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 whitespace-nowrap">
                    {getDateDifferenceFormatted(row?.benefit_date) || "__"}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 break-words">
                    {row?.member_id || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 break-all">
                    {row?.policy_number || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 leading-tight">
                    {row?.policy_holder || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 leading-tight">
                    {row?.type || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900">
                    {row?.relation_with_subscriber || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900 break-all">
                    {row?.subscriber_member_id || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900">
                    {row?.network || t("N/A")}
                  </td>
                  <td className="px-1.5 py-1.5 border-r border-gray-200 text-[11px] text-gray-900">
                    {row?.subrogation || t("N/A")}
                  </td>

                </tr>
                <tr className="bg-white">
                  <td colSpan={10} className="px-0 py-0">
                    <div className="bg-white border-t border-gray-100">
                      <div className="overflow-hidden">
                        <div className="flex bg-[#64748b] text-white text-[11px] font-bold uppercase tracking-wider">
                          <div className="w-[10%] px-2 py-1.5 border-r border-white/20 whitespace-nowrap bg-gray-600 text-center">
                            {t("Classes")}
                          </div>
                          <div className="w-[45%] flex">
                            <div className="flex-1 px-2 py-1.5 border-r border-white/20">
                              {t("Class")}
                            </div>
                            <div className="flex-1 px-2 py-1.5 border-r border-white/20">
                              {t("Group")}
                            </div>
                            <div className="flex-1 px-2 py-1.5 border-r border-white/20">
                              {t("Plan")}
                            </div>
                          </div>
                          <div className="w-[15%] px-2 py-1.5 border-r border-white/20 whitespace-nowrap bg-gray-600 text-center">
                            {t("Cost to Beneficiaries")}
                          </div>
                          <div className="w-[30%] flex">
                            <div className="flex-1 px-2 py-1.5 border-r border-white/20">
                              {t("Copay")}
                            </div>
                            <div className="flex-1 px-2 py-1.5">
                              {t("Maxcopay")}
                            </div>
                          </div>
                        </div>
                        <div className="flex bg-white text-[11px] text-gray-800 min-h-[32px]">
                          <div className="w-[10%] border-r border-gray-300 bg-gray-50"></div>
                          <div className="w-[45%] flex">
                            <div className="flex-1 px-2 py-1.5 border-r border-gray-200 break-words font-medium">
                              {row?.class_value || "---"}
                            </div>
                            <div className="flex-1 px-2 py-1.5 border-r border-gray-200 break-words font-medium uppercase">
                              {row?.class_group_value || "---"}
                            </div>
                            <div className="flex-1 px-2 py-1.5 border-r border-gray-300 break-words font-medium">
                              {row?.class_plan_value || "---"}
                            </div>
                          </div>
                          <div className="w-[15%] border-r border-gray-300 bg-gray-50"></div>
                          <div className="w-[30%] flex font-bold text-gray-900">
                            <div className="flex-1 px-2 py-1.5 border-r border-gray-200">
                              {row?.cost_to_ben_copay_value ?? "---"}
                            </div>
                            <div className="flex-1 px-2 py-1.5">
                              {row?.cost_to_ben_max_copay_value ?? "---"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>


        {/* Collapsible Benefits Section */}
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <div className="px-1.5 pb-4 bg-gray-50/50 border-t border-gray-200">
            <div className="flex items-center gap-2 py-3 px-1">
              <Typography
                className="!font-bold !text-[16px] !text-gray-700"
                variant="caption"
              >
                {t("List OF Benefits")} ({row?.items?.length ?? 0})
              </Typography>
              <div className="ml-auto no-print">
                <CustomFilterInput
                  placeholder={t("Search from THIS coverage only...")}
                  value={localSearchTerm}
                  onChange={(e) => setLocalSearchTerm(e.target.value)}
                  className="!w-[280px] !bg-white"
                />
              </div>
            </div>
            <EligibilityItemsTable
              data={row?.items}
              searchTerm={localSearchTerm}
            />
          </div>
        </Collapse>

      </div>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="mb-6 mt-[-1px] w-full flex items-center justify-center gap-2 cursor-pointer bg-blue-50/50 hover:bg-blue-100/50 py-2.5 transition-all border border-gray-200 rounded-b-md text-blue-700 font-bold uppercase text-[11px] tracking-widest shadow-sm"
      >
        {t("Table of Benefits")}
        {isOpen ? (
          <KeyboardArrowUpIcon fontSize="small" />
        ) : (
          <KeyboardArrowDownIcon fontSize="small" />
        )}
      </div>
    </>
  );
}

export default function EligibilityDetailsTable({
  items = [],
  loading,
  searchTerm = "",
  setSearchTerm,
}) {
  const { t } = useTranslation();

  if (loading) return <div>{t("Loading...")}</div>;

  return (
    <div className="w-full flex flex-col">
      {items?.length === 0 ? (
        <div className="px-4 py-8 text-center text-gray-400 border border-gray-200 rounded-md bg-white shadow-sm">
          {t("No coverages available.")}
        </div>
      ) : (
        items?.map((row, index) => (
          <CoverageCard key={index} row={row} index={index} />
        ))
      )}
    </div>
  );
}
